// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for metadata
export const metadataState = $state([]);

// Update metadata by key and value
export function updateMetadata(key, value) {
  const index = metadataState.findIndex(item => item.key === key);
  
  if (index !== -1) {
    // Update existing entry
    metadataState[index].value = value;
  } else {
    // Add new entry
    metadataState.push({ key, value });
  }
}

// Add helper functions for clearing and adding items
export function clearMetadataState() {
  metadataState.length = 0;
}

export function addMetadataItem(item) {
  metadataState.push(item);
}

export function removeMetadataItemById(id) {
    const index = metadataState.findIndex(metadata => metadata.id === id);
    if (index !== -1) {
        metadataState.splice(index, 1);
    }
}

export function setMetadataState(metadata) {
  // Clear existing event groups first
  clearMetadataState();
  metadata.forEach(meta =>{
    metadataState.push({
        ...meta
    });
  })
}